<template>
  <div v-if="loaded && !artistError" class="container-bg-img">
    <div
      class="background-image-blur"
      :style="{
        backgroundImage:
          'url(' +
          (artist?.thumbnails?.m_hor_dt
            ? artist.thumbnails.m_hor_dt
            : artist?.image_url) +
          ')',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }"
    ></div>
    <div class="overlay-bg-img"></div>
  </div>
  <profile-layout
    v-if="loaded && !artistError"
    :image="artist?.image_url"
    :profile="artist.name"
    type="artist"
    :previsualization="!artist?.enabled"
    @update:open-share="openShareModal()"
  >
    <template #header>
      <!-- Pixels -->
      <ga-pixel
        v-if="artist?.google_pixel_js"
        :pixel="artist.google_pixel_js"
      />
      <fb-pixel
        v-if="artist?.facebook_pixel_js"
        :pixel="artist.facebook_pixel_js"
      />
      <!-- End Pixels -->
      <div class="profile-header flex-col">
        <div class="content content-top">
          <section class="profiles-titles">
            <h1 class="artist-title title w-full lg:w-3/5 mb-4 md:mb-0">
              {{
                $t("profiles.titles.concertsTicketsOf", { artist: artist.name })
              }}
            </h1>
            <h2 class="profile-subtitle font-museo-500">
              {{
                $t("profiles.titles.tourConcertTickets", {
                  date: yearPeriodFormatter()
                })
              }}
            </h2>
          </section>
          <!-- Social buttons Desktop -->
          <section class="social-buttons lg:block hidden">
            <section class="flex gap-3">
              <spotify-widget
                v-if="artist.spotify_id"
                :id="artist.spotify_id"
                type="artist"
                height="152"
                width="446"
              />
              <span>
                <moment-miniature :artist-slug="artist.slug" />
              </span>
            </section>
            <social-media
              v-if="artist.links.length > 0"
              class="mt-[20px]"
              padding="pb-0"
              :medias-to-show="formatSocialMedia(artist.links)"
              :web="
                formatSocialMediaUrl(artist.links).web
                  ? formatSocialMediaUrl(artist.links).web
                  : ''
              "
              :facebook="
                formatSocialMediaUrl(artist.links).facebook
                  ? formatSocialMediaUrl(artist.links).facebook
                  : ''
              "
              :spotify="
                formatSocialMediaUrl(artist.links).spotify
                  ? formatSocialMediaUrl(artist.links).spotify
                  : ''
              "
              :twitter="
                formatSocialMediaUrl(artist.links).twitter
                  ? formatSocialMediaUrl(artist.links).twitter
                  : ''
              "
              :instagram="
                formatSocialMediaUrl(artist.links)?.instagram
                  ? formatSocialMediaUrl(artist.links).instagram
                  : ''
              "
              :youtube="
                formatSocialMediaUrl(artist.links).youtube
                  ? formatSocialMediaUrl(artist.links).youtube
                  : ''
              "
              :soundcloud="
                formatSocialMediaUrl(artist.links).soundcloud
                  ? formatSocialMediaUrl(artist.links).soundcloud
                  : ''
              "
              :tiktok="
                formatSocialMediaUrl(artist.links).tiktok
                  ? formatSocialMediaUrl(artist.links).tiktok
                  : ''
              "
              :other="
                formatSocialMediaUrl(artist.links).other
                  ? formatSocialMediaUrl(artist.links).other
                  : ''
              "
              :rounded="0"
            />
          </section>
          <!-- Interaction followers buttons -->
          <section class="interaction-buttons">
            <div class="follow-btn-sections">
              <follow-button
                type="artist"
                class="lg:order-1 order-2"
                :item="artist"
                theme="follow-profile-btn"
              />
              <span
                class="followers lg:order-2 order-1 md:text-base text-sm lg:ml-9 text-nowrap"
              >
                {{ artist.followers_count }}
                {{ $t("profiles.labels.followers") }}
              </span>
            </div>
            <div
              class="share-button lg:flex hidden lg:flex-col order-3 cursor-pointer"
            >
              <w-icon
                :img="require('@/assets/images/ic-share-circle-topaz.svg')"
                :size="41"
                @click="openShareModal()"
              />
            </div>
          </section>
        </div>
      </div>
    </template>
    <template #top-sections>
      <nav class="block lg:hidden top-sections">
        <ul class="flex justify-evenly space-x-4">
          <li
            v-if="eventsToArtist?.length"
            class="cursor-pointer"
            @click="scrollToSection('wegow__artist__concerts')"
          >
            {{ $t("profiles.titles.concerts") }}
          </li>
          <li
            v-if="media?.length"
            class="cursor-pointer"
            @click="scrollToSection('wegow__artist__gallery')"
          >
            {{ $t("profiles.titles.gallery") }}
          </li>
          <li
            class="cursor-pointer"
            @click="scrollToSection('wegow__artist__followers')"
          >
            {{ $t("profiles.labels.followers") }}
          </li>
        </ul>
      </nav>
    </template>
    <template #content>
      <!-- Description Slot -->

      <!-- Information -->
      <section
        class="flex flex-col justify-start section-container one-col information-section order-1 relative"
        :class="!artist ? 'w-96 h-96' : 'w-full'"
      >
        <section class="pb-8 relative">
          <h3 class="h3-titles">
            {{ $t("profiles.labels.informationOf", { name: artist.name }) }}
          </h3>
          <show-more
            v-if="artist?.html_personalization?.html_description"
            :text="artist.html_personalization.html_description"
            :html-personalization="true"
            class="description__html"
          />
          <div v-else-if="artist.description">
            <span class="text-s text-information concerts-locations__text">
              <show-more :text="artist.description" />
            </span>
          </div>
        </section>

        <!-- Social Button Mobile -->
        <section class="social-buttons lg:hidden block">
          <article class="pb-4">
            <spotify-widget
              v-if="artist.spotify_id"
              :id="artist.spotify_id"
              type="artist"
              height="152"
            />
            <div
              v-if="showPrevious"
              style="height: 152px;background-color: rgb(52, 47, 47);"
            ></div>
          </article>

          <social-media
            v-if="artist.links.length > 0"
            class="mt-[20px] pb-8"
            :medias-to-show="formatSocialMedia(artist.links)"
            :web="
              formatSocialMediaUrl(artist.links).web
                ? formatSocialMediaUrl(artist.links).web
                : ''
            "
            :facebook="
              formatSocialMediaUrl(artist.links).facebook
                ? formatSocialMediaUrl(artist.links).facebook
                : ''
            "
            :spotify="
              formatSocialMediaUrl(artist.links).spotify
                ? formatSocialMediaUrl(artist.links).spotify
                : ''
            "
            :twitter="
              formatSocialMediaUrl(artist.links).twitter
                ? formatSocialMediaUrl(artist.links).twitter
                : ''
            "
            :instagram="
              formatSocialMediaUrl(artist.links)?.instagram
                ? formatSocialMediaUrl(artist.links).instagram
                : ''
            "
            :youtube="
              formatSocialMediaUrl(artist.links).youtube
                ? formatSocialMediaUrl(artist.links).youtube
                : ''
            "
            :soundcloud="
              formatSocialMediaUrl(artist.links).soundcloud
                ? formatSocialMediaUrl(artist.links).soundcloud
                : ''
            "
            :tiktok="
              formatSocialMediaUrl(artist.links).tiktok
                ? formatSocialMediaUrl(artist.links).tiktok
                : ''
            "
            :rounded="0"
          />
        </section>
        <!-- <Suspense>
          <template #default>
            <div class="mt-4">
              <modal-report :object-id="artist.id" type="artist" />
            </div>
          </template>
        </Suspense> -->
        <!-- <div class="gradient-container">
          <div class="followers-gradient scroll lg:inline-block hidden"></div>
        </div> -->
      </section>
      <!-- Concerts -->
      <w-shadow
        v-if="eventsToArtist?.count > 0"
        class="relative one-col order-2"
      >
        <template #contain>
          <section
            id="wegow__artist__concerts"
            class="section-container artist-concerts px-3"
          >
            <h3
              class="h3-titles"
              :class="{
                'has-show-more': eventsToArtist.count > 2
              }"
            >
              {{ $t("profiles.titles.concerts") }}
            </h3>
            <button
              v-if="eventsToArtist.count > 2"
              class="text-color-topaz-light text-sm"
              @click="showAllConcerts()"
            >
              {{ $t("general.header.dropdown.showAll") }}
            </button>
            <section class="related-col">
              <event-card-large
                v-for="event in eventsToArtist.events"
                :key="event.id"
                :event="event"
                type="profiles"
                :open-external="event.has_waiting_room || event.has_options"
              />
              <!-- ThreeLastConcerts -->
              <!-- <section v-if="windowWidth < 1024" class="flex flex-col gap-3">
                <event-card
                  v-for="event in eventsToArtist.events"
                  :key="event.id"
                  :event="event"
                  type="large"
                  open-external
                />
              </section> -->

              <!-- Show More Concerts -->
              <span v-if="showMoreConcerts" class="flex flex-col gap-2">
                <event-card-large
                  v-for="event in eventsToArtist.events"
                  :key="event.id"
                  class="lg:hidden inline-block"
                  :event="event"
                  type="profiles"
                  :open-external="event.has_waiting_room || event.has_options"
                />
              </span>
              <show-more-elements
                v-if="eventsToArtist.count >= 3"
                class="mb-14 lg:hidden flex justify-center"
                :show-more-text="$t('wegow.showMore')"
                :show-less-text="$t('wegow.showLess')"
                :next-page="hasNextPage"
                @show-more="$event === true ? showMorePagination() : showLess()"
              ></show-more-elements>
            </section>
          </section>
        </template>
      </w-shadow>

      <smart-clip
        v-if="showAds"
        class="two-col lg:order-5 order-3"
        :type="'sc-top'"
        :type-aux="'sc-oop'"
      />
      <smart-clip
        v-if="showAds"
        class="two-col lg:order-6 order-4"
        :type="'sc-mpu-top'"
      />
      <!-- Followers -->
      <w-shadow class="lg:order-3 order-7 lg:mb-0 mb-4 lg:h-[400px] h-auto">
        <template #contain>
          <section
            id="wegow__artist__followers"
            class="section-container followers-container relative"
            :class="{ 'no-paddings': windowWidth < 475 }"
          >
            <followers-section
              :profile-followers="artistFollowers"
              :followers-count="artist.followers_count"
              type="Artist"
              @open-followers="showFollowersModal = true"
            ></followers-section>
          </section>
        </template>
      </w-shadow>

      <!-- Gallery section -->
      <section
        v-if="getValidMedias(media)?.length"
        id="wegow__artist__gallery"
        class="section-container lg:order-4 order-6"
        :class="[
          eventsToArtist?.count === 0 ? 'two-col' : 'one-col',
          { 'no-paddings': windowWidth < 475 }
        ]"
      >
        <h3
          class="h3-titles flex flex-col gap-0 items-baseline"
          :class="{
            'has-show-more': getValidMedias(media)?.length > 2,
            'padding-left': windowWidth < 475
          }"
        >
          {{ $t("profiles.titles.gallery") }}
          <button
            v-if="getValidMedias(media)?.length > 2"
            class="text-color-topaz-light text-sm max-w-fit md:mb-5 mb-3 font-normal"
            @click="showGalleryModal = true"
          >
            {{ $t("general.header.dropdown.showAll") }}
          </button>
        </h3>

        <section class="relative">
          <gallery-section
            :images="getValidMedias(media)"
            :navigation="false"
            type="artists"
          />
          <div class="slider-gradient"></div>
        </section>
      </section>
      <!-- Artist Related -->
      <section
        v-if="artistsRelatedToArtist?.length"
        class="profile-sub-sections-title section-container relative"
        :class="[
          !getValidMedias(media)?.length && eventsToArtist.count > 0
            ? 'one-col lg:order-4 order-5'
            : 'two-col lg:order-7 order-5',
          { 'no-paddings': windowWidth < 475 }
        ]"
      >
        <div class="slider-gradient"></div>
        <related-artists
          :artists-related="artistsRelatedToArtist"
          :breakpoints="formatterBreakpoint"
        ></related-artists>
      </section>
      <smart-clip
        v-if="showAds"
        class="order-8"
        :class="{ 'lg:order-6': getValidMedias(media)?.length === 0 }"
        :type="'sc-superbanner-btf'"
      />
      <smart-clip v-if="showAds" class="order-8" :type="'sc-mpu-btf'" />

      <!-- Events related -->
      <section
        v-if="eventsRelatedToArtist?.events?.length"
        class="profile-sub-sections-title large-container section-container relative"
        :class="[
          !getValidMedias(media)?.length && !artistsRelatedToArtist?.length
            ? 'one-col lg:order-4 order-5'
            : 'two-col lg:order-7 order-3',
          { 'no-paddings': windowWidth < 475 }
        ]"
      >
        <related-events
          page="artist"
          breakpoints="six-cards"
          :events-related="eventsRelatedToArtist.events"
        ></related-events>
        <div class="slider-gradient"></div>
      </section>
    </template>
  </profile-layout>
  <div v-else-if="!artistError" class="flex flex-col justify-center">
    <wegow-loader class="min-h-screen" />
  </div>
  <not-found v-else :show-layout="false" />
  <smart-intxt v-if="showAds" class="two-col" :type="'smartIntxt'" />
  <dynamic-ad
    v-if="
      showAds &&
        windowWidth > 768 &&
        artist.ads &&
        artist.ads['desktop_artist_dynamic'] &&
        artist.ads[`desktop_artist_intext`] === null
    "
    :values="artist.ads['desktop_artist_dynamic'].values"
  />
  <!-- Share Modal -->
  <Suspense>
    <template #default>
      <ShareModal
        v-if="openShareVar"
        category="artist"
        @close="openShareVar = false"
      ></ShareModal>
    </template>
  </Suspense>
  <!-- Profiles Modal -->
  <modal-profiles
    v-if="showFollowersModal"
    :title="
      `${artist.followers_count} ${$t(
        'profiles.labels.followers'
      ).toLowerCase()}`
    "
    type="modal-large"
    @close="showFollowersModal = false"
  >
    <template #modalProfile>
      <section
        v-for="profile in artistFollowers"
        :key="profile.id"
        class="artist-followers"
      >
        <profile-card
          :profile="profile"
          :followers-count="artist.followers_count"
          type="profile-sm-card"
        />
      </section>
      <section
        v-for="user in artistFollowers"
        :key="user.id"
        class="xs:hidden block"
      >
        <user-card :user="user" />
      </section>
    </template>
  </modal-profiles>

  <modal-profiles
    v-if="showGalleryModal"
    :title="$t('profiles.titles.gallery')"
    type="medium"
    @close="showGalleryModal = false"
  >
    <template #modalProfile>
      <gallery-section
        :images="getValidMedias(media)"
        :navigation="false"
        type="artists"
        :modal="true"
      />
    </template>
  </modal-profiles>
  <modal-profiles
    v-if="showConcertsModal"
    :title="$t('general.header.concerts')"
    type="medium"
    :gradient="eventsToArtist.count > pageSize"
    :total-items="eventsToArtist.count"
    :page="currentPage"
    :items-per-page="pageSize"
    @next-page="nextPage()"
    @close="closeConcertModal()"
  >
    <template #modalProfile>
      <section class="flex flex-wrap gap-[14px] relative">
        <div
          v-for="event in eventsToArtist.events"
          :key="event.id"
          class="concert-modal"
        >
          <event-card
            v-if="event"
            :event="event"
            type="small"
            :is-link="showLink"
            open-external
            @empty-ad="deleteAdRelatedToArtist($event)"
          />
        </div>
      </section>
    </template>
  </modal-profiles>
</template>

<script setup>
import NotFound from "@/views/general/NotFound";
import FbPixel from "@/components/general/FbPixel.vue";
import FollowButton from "@/components/general/FollowButton.vue";
import GaPixel from "@/components/general/GaPixel.vue";
import ProfileLayout from "@/components/general/ui/profiles/ProfileLayout.vue";
import WegowLoader from "@/components/general/ui/WegowLoader.vue";
import ShowMore from "@/components/general/ui/elements/ShowMoreComponent.vue";
import SocialMedia from "@/components/general/ui/elements/SocialMediaComponent.vue";
import WIcon from "@/components/general/ui/elements/WIcon.vue";
import SpotifyWidget from "@/components/magazine/widgets/SpotifyWidget.vue";
import FollowersSection from "@/components/general/ui/profiles/FollowersSection.vue";
import ArtistCard from "@/components/wegow/ui/cards/ArtistCard.vue";
import EventCard from "@/components/wegow/ui/cards/EventCard.vue";
import EventCardLarge from "@/components/wegow/ui/cards/EventCardLarge.vue";
import ProfileCard from "@/components/wegow/ui/cards/ProfileCard.vue";
import UserCard from "@/components/general/ui/UserCard.vue";
import MomentMiniature from "@/components/wegow/moment/MomentMiniature";
import RelatedArtists from "@/components/general/ui/profiles/RelatedArtists.vue";
import RelatedEvents from "@/components/general/ui/profiles/RelatedEvents.vue";
import ShowMoreElements from "@/components/general/ui/elements/ShowMoreElements.vue";
import { useI18n } from "vue-i18n";

import DynamicAd from "@/components/general/ads/smartclip/DynamicAd.vue";
import SmartClip from "@/components/general/ads/smartclip/SmartClip.vue";
import SmartIntxt from "@/components/general/ads/smartclip/SmartIntxt.vue";
import WegowButton from "@/components/general/forms/WegowButton";

import { useStatsStore } from "@/stores/modules/stats";
import { useUserStore } from "@/stores/modules/user";

import { useArtist } from "@/composables/useArtist";
import { useEvent } from "@/composables/useEvent";
import { useUser } from "@/composables/useUser";
import { BREAKPOINTS } from "@/constants.js";
import { useModalHandler } from "@/plugins/useModalHandler";
import {
  formatSocialMediaUrl,
  formatSocialMedia
} from "@/plugins/social-media-formater";
import {
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  ref,
  defineAsyncComponent,
  watch,
  computed
} from "vue";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { metas } from "@/plugins/mixins/metas";
import { yearPeriodFormatter } from "@/plugins/date-formater";

const GallerySection = defineAsyncComponent(() =>
  import("@/components/wegow/ui/GallerySection.vue")
);
const ShareModal = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalShare.vue")
);
// const ModalReport = defineAsyncComponent(() =>
//   import("@/components/general/modals/ModalReport.vue")
// );
const ModalProfiles = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalProfiles.vue")
);
const WShadow = defineAsyncComponent(() =>
  import("@/components/general/ui/WShadow.vue")
);

const loaded = ref(true);
const route = useRoute();
const router = useRouter();
const {
  media,
  details: artist,
  artistsRelatedToArtist,
  indexedLocations,
  getDetails,
  getArtistMedia,
  getArtistsRelatedToArtist,
  getLocations
} = useArtist();
const {
  eventsToArtist,
  eventsRelatedToArtist,
  getEventsToArtist,
  getEventsRelatedToArtist,
  getEventsToArtistInfinite,
  deleteAdRelatedToArtist
} = useEvent();
const { artistFollowers, isAuth, getArtistFollowers } = useUser();
const { openPreviewModal, openErrorModal, IMAGE_PREVIEW } = useModalHandler();
const openShareVar = ref(false);
const showPrevious = ref(true);
const showSpotify = ref(false);
const artistError = ref(false);
const showFollowersModal = ref(false);
const showGalleryModal = ref(false);
const showConcertsModal = ref(false);
const showMoreConcerts = ref(false);
const currentPage = ref(1);
const windowWidth = ref(0);
const isMobile = ref(false);
const { t } = useI18n();
windowWidth.value = window.innerWidth;
const pageSize = ref(windowWidth.value < 475 ? 3 : 20);
const showAds = ref(false);

const statsStore = useStatsStore();
const userStore = useUserStore();

// Computed
const totalPages = computed(() => {
  return Math.ceil(eventsToArtist.value.count / pageSize.value);
});
const formatterBreakpoint = computed(() => {
  if (!getValidMedias(media.value)?.length && eventsToArtist.value.length > 0) {
    return "small-short";
  } else {
    return "large";
  }
});
const openShareModal = () => {
  openShareVar.value = !openShareVar.value;
};
const getVideoImagePreview = url => {
  let id = url?.match(/embed\/([A-Za-z0-9-_]{11})/);
  if (!id?.length) return;
  id = id[0].replace("embed/", "");
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
};

const init = async route => {
  try {
    loaded.value = false;
    metas.methods.setLanguage();
    metas.methods.setCanonical(route);
    await getDetails(route.params.slug);

    if (artist.value && artist.value.id) {
      handleArtistData(route);
    } else {
      handleArtistError();
    }
  } catch (error) {
    handleArtistError();
  }
};

onBeforeMount(async () => {
  await init(route);
  window.removeEventListener("resize", handleResize);
});
onBeforeRouteUpdate(to => init(to));
onMounted(async () => {
  window.addEventListener("resize", updateScreen());
  await sendStats();
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", toggleStickyPosition);
});

const handleArtistData = route => {
  const year = yearPeriodFormatter();
  showAds.value = ![691553, 5127559].includes(artist.value.id);

  const { title, description } = getArtistMetas(year);
  setMetas(title, description, route);
  setSchema();
  setSocialMeta(title, description);

  loaded.value = true;
  getRelated();
};

const handleArtistError = () => {
  loaded.value = true;
  artistError.value = true;
  metas.methods.setIndex(false);
};

const getArtistMetas = year => {
  if (artist.value.html_personalization) {
    return {
      title: artist.value.html_personalization.head_title,
      description: artist.value.html_personalization.head_meta_description
    };
  }

  return {
    title: t("general.metas.artistTitle", {
      name: artist.value.name,
      year: year
    }),
    description: t("general.metas.artistDescription", {
      name: artist.value.name,
      year: `${year}`
    })
  };
};

const setMetas = (title, description, route) => {
  metas.methods.setMetasHtml(
    {
      title,
      description,
      alternates: artist.value.alternates,
      noIndex: !artist.value.index
    },
    route,
    router
  );
};

const setSchema = () => {
  const schema = {
    "@context": "https://schema.org/",
    "@type": "Artist",
    description: artist.value.description,
    name: artist.value.name,
    artist: {
      "@type": "Person",
      name: artist.value.name
    }
  };
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.innerHTML = JSON.stringify(schema);
  document.head.appendChild(script);
};

const setSocialMeta = (title, description) => {
  const image = artist?.value.thumbnails?.m_hor_dt || artist?.value.image_url;

  metas.methods.setOpenGraph({ title, description, image });
  metas.methods.setTwitterCard({ title, description, image });
};

const getRelated = async () => {
  const artistData = artist.value;
  if (!artistData) return;

  await Promise.allSettled([
    getArtistMedia(artistData),
    getArtistFollowers(artistData),
    getArtistsRelatedToArtist(artistData),
    getEventsRelatedToArtist(artistData, showAds.value),
    handleArtistEvents(artistData)
  ]);
};

const handleArtistEvents = async artistData => {
  if (windowWidth.value > 475) {
    await getEventsToArtist(artistData);
  } else {
    getThreeLastConcerts();
  }
};

const sendStats = async () => {
  // Enviamos los datos para las stats
  const params = {
    campaign: "page_view",
    id: userStore.userDetail.unsubscribe_token
      ? userStore.userDetail.unsubscribe_token
      : sessionStorage.tt_sessionId,
    uri: route.fullPath,
    pageName: route.name
  };
  if (!window.location.href.includes("wegowlocal")) {
    await statsStore.sendToStatsService(params);
  }
};

const handleResize = () => {
  updateScreen();
  toggleStickyPosition();
};
const getValidMedias = media => {
  if (media?.length > 0) {
    return media.filter(m => m.type === 1 || m.thumbnails);
  } else {
    return [];
  }
};
const getThreeLastConcerts = async () => {
  // return eventsToArtist.value.slice(0, 3);
  pageSize.value = 3;
  await getEventsToArtist(artist.value, { page_size: pageSize.value });
};
const hasNextPage = computed(() => {
  if (currentPage.value === totalPages.value) {
    return false;
  } else {
    return true;
  }
});
const updateScreen = () => {
  windowWidth.value = window.innerWidth;
};
const toggleStickyPosition = () => {
  const elementSticky = document.getElementById("gradient-concert");
  if (elementSticky) {
    if (eventsToArtist.value.length < 3) {
      elementSticky.style.position = "absolute";
    } else {
      elementSticky.style.position = "sticky";
    }
  }
};
watch(
  windowWidth,
  async newWidth => {
    updateScreen();
    if (windowWidth.value === 475) {
      isMobile.value = true;
      await getThreeLastConcerts();
    }
  },
  { immediate: true }
);
watch(
  currentPage,
  newCurrent => {
    artist.value.page = newCurrent;
    artist.value.page_size = pageSize.value;
    if (currentPage.value > 1 && showConcertsModal.value && artist.value.id) {
      getEventsToArtistInfinite(artist.value);
    } else if (
      currentPage.value === 1 &&
      !showConcertsModal.value &&
      windowWidth.value > 475 &&
      artist.value.id
    ) {
      artist.value.page_size = 10;
      getEventsToArtist(artist.value);
    }
  },
  { immediate: true }
);

const scrollToSection = id => {
  window.scrollTo({
    top: document.getElementById(id).offsetTop,
    behavior: "smooth"
  });
};

const closeConcertModal = () => {
  showConcertsModal.value = false;
  currentPage.value = 1;
  if (windowWidth.value < 475) {
    pageSize.value = 3;
  }
  getEventsToArtist(artist.value, {
    page: currentPage.value,
    page_size: pageSize.value
  });
};

const showAllConcerts = () => {
  showConcertsModal.value = true;
  pageSize.value = 20;
  getEventsToArtist(artist.value, {
    page_size: pageSize.value,
    page: currentPage.value++
  });
};

const nextPage = () => {
  currentPage.value++;
};

const showMorePagination = async () => {
  if (pageSize.value !== 3) {
    currentPage.value++;
    pageSize.value = 10;
  }
  const params = {
    id: artist.value.id,
    page: currentPage.value,
    page_size: pageSize.value,
    count: true
  };
  if (pageSize.value !== 3) {
    await getEventsToArtistInfinite(params);
  } else {
    pageSize.value = 10;
    await getEventsToArtist(artist.value, {
      page: currentPage.value,
      page_size: pageSize.value
    });
  }
};

const showLess = async () => {
  currentPage.value = 1;
  pageSize.value = 3;
  let params = {
    page: currentPage.value,
    count: true,
    page_size: pageSize.value
  };
  await getEventsToArtist(artist.value, params);
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};
</script>

<style lang="scss">
@import "./artist-profile.scss";
@import "@/components/general/ui/profiles/profiles.scss";
</style>
<style lang="scss" scoped>
.related-col {
  margin-bottom: 0;
  @media screen and (min-width: $screen-sm) {
    margin-bottom: 50px;
  }
}
</style>
